export const DEFAULT_SITE_URL = 'https://kasbly.com';

function cleanPath(path: string): string {
  if (!path || path === '/') return '';
  return path.startsWith('/') ? path : `/${path}`;
}

export function normalizeSiteUrl(value?: string): string {
  const raw = value?.trim();
  if (!raw) return DEFAULT_SITE_URL;

  const candidate = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;

  try {
    return new URL(candidate).origin;
  } catch {
    return DEFAULT_SITE_URL;
  }
}

export function absoluteUrl(pathOrUrl: string, baseUrl = DEFAULT_SITE_URL): string {
  return new URL(pathOrUrl || '/', normalizeSiteUrl(baseUrl)).toString();
}

export function buildLocalizedAlternates(
  path: string,
  locales: readonly string[],
  defaultLocale: string,
  options: { absolute?: boolean; baseUrl?: string } = {},
): Record<string, string> {
  const pathname = cleanPath(path);
  const origin = normalizeSiteUrl(options.baseUrl);
  const prefix = options.absolute ? origin : '';
  const alternates: Record<string, string> = {};

  for (const locale of locales) {
    alternates[locale] = `${prefix}/${locale}${pathname}`;
  }

  const fallbackLocale = locales.includes(defaultLocale) ? defaultLocale : locales[0];
  if (fallbackLocale) {
    alternates['x-default'] = `${prefix}/${fallbackLocale}${pathname}`;
  }

  return alternates;
}

export function serializeJsonLd(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
